import {
  KEY, DEFAULT_SEARCH_REQUEST, ORIGIN_LINK,
  DEFAULT_PLACEHOLDER_IMAGE, DEFAULT_PAGE, KEY_YANDEX, URL_YANDEX, TRANSLATE_LANGUAGE_YANDEX,
} from '../../constants/constants';
import Slider from '../slider';

const SPINER_STYLE_DISPLAY = 'spinner--display';
const SPINER_STYLE_HIDDEN = 'spinner--not-display';
const RESPONSE_STATUS_TRUE = 'True';
const MOVIE_ON_PAGE = 10;
const MAX_RATING_IMDB = 10;
const EmptySerchRequest = '';
const DEFOLT_TEXT_FOR_TRANSLATE_AREA = 'Showing results for';

export default class SearchService {
  constructor() {
    this.page = DEFAULT_PAGE;
    this.numberPagesResult = DEFAULT_PAGE;
  }

  async getBySearhcRequest(searchRequest = DEFAULT_SEARCH_REQUEST, page = DEFAULT_PAGE) {
    let movies;
    let moviesInfo;
    let searchRequestTranslated;
    try {
      this.startLoading();
      if (this.checkSerchLanguage(searchRequest)) {
        const dResponseTranslate = await fetch(`${URL_YANDEX}key=${KEY_YANDEX}&text=${searchRequest}&lang=${TRANSLATE_LANGUAGE_YANDEX}`);
        const ResponseTranslate = await dResponseTranslate.json();
        searchRequestTranslated = ResponseTranslate.text;
        this.addTextToTranslateArea(`${DEFOLT_TEXT_FOR_TRANSLATE_AREA} ${searchRequestTranslated}`);
      } else {
        searchRequestTranslated = searchRequest;
        this.addTextToTranslateArea();
      }
      const dResponse = await fetch(`${ORIGIN_LINK}?apikey=${KEY}&s=${searchRequestTranslated}&page=${page}&t=movie`);
      const response = await dResponse.json();
      this.calculeteNumberOfPages(response.totalResults);
      if (response.Response === RESPONSE_STATUS_TRUE) {
        const ids = response.Search.map((filmFromRespons) => filmFromRespons.imdbID);
        movies = await this.getByIds(ids);
        moviesInfo = await this.formatMovie(movies);
        this.createSlider(moviesInfo);
      } else {
        this.createFalseResponseArea(response.Error);
      }
      this.endLoading();
    } catch (error) {
      this.endLoading();
      this.createFalseResponseArea(error);
    }
    return movies;
  }

  startLoading() {
    this.spinner = document.createElement('div');
    this.spinner.innerHTML = `<div id="escapingBallG">
      <div id="escapingBall_1" class="escapingBallG"></div>
    </div>`;
    this.spinner.classList.add('spinner');
    document.body.append(this.spinner);
    this.spinner.classList.add(SPINER_STYLE_DISPLAY);
    this.spinner.classList.remove(SPINER_STYLE_HIDDEN);
  }

  endLoading() {
    this.spinner.classList.add(SPINER_STYLE_HIDDEN);
    this.spinner.classList.remove(SPINER_STYLE_DISPLAY);
    this.spinner.remove();
  }

  async getByIds(ids) {
    this.movies = await Promise.all(ids.map(async (id) => {
      const dMovie = await fetch(`${ORIGIN_LINK}?apikey=${KEY}&i=${id}`);
      const movie = await dMovie.json();
      return movie;
    }));
    return this.movies;
  }

  formatMovie(movies) {
    this.moviesDate = movies.map(({
      Title, Poster, Year, imdbID, imdbRating,
    }) => ({
      idImdb: imdbID,
      title: Title,
      poster: Poster === 'N/A' ? DEFAULT_PLACEHOLDER_IMAGE : Poster,
      year: Year,
      rating: imdbRating,
    }));
    return this.moviesDate;
  }

  createSlideWrapper(movies) {
    this.createSliderWrapper();
    this.createSliderArea();
    const swiper = document.querySelector('.swiper-wrapper');
    this.moviesArray = movies;
    this.moviesArray.forEach((mivie) => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      const slideTitle = document.createElement('div');
      slideTitle.classList.add('slide-title');
      slideTitle.innerHTML = `<a href=https://www.imdb.com/title/${mivie.idImdb}/videogallery/>${mivie.title}</a>`;
      slide.appendChild(slideTitle);

      const slidePoster = document.createElement('div');
      slidePoster.classList.add('slide-poster');
      slidePoster.style.backgroundImage = `url(${mivie.poster})`;
      slide.appendChild(slidePoster);

      const slideYear = document.createElement('div');
      slideYear.classList.add('slide-year');
      slideYear.innerHTML = `${mivie.year}`;
      slide.appendChild(slideYear);
      swiper.appendChild(slide);

      const slideRating = document.createElement('div');
      slideRating.classList.add('slide-rating');
      slideRating.innerHTML = `${mivie.rating} / ${MAX_RATING_IMDB}`;
      slide.appendChild(slideRating);
      swiper.appendChild(slide);
    });
  }

  createSliderArea() {
    this.sliderArea = document.querySelector('.slider-area');
    this.sliderArea.innerHTML = `<div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div> `;
    this.sliderArea.appendChild(this.slider);
  }

  createSliderWrapper() {
    this.slider = document.createElement('div');
    this.slider.classList.add('swiper-container');
    this.slider.innerHTML = ` 
    <div class="swiper-wrapper"></div>
    <div class="swiper-pagination"></div>`;
  }

  calculeteNumberOfPages(totalResults) {
    this.numberPagesResult = Math.ceil(Number(totalResults) / MOVIE_ON_PAGE);
  }

  createSlider(movies) {
    this.createSlideWrapper(movies);
    const slider = new Slider('.swiper-container', {
      updateOnWindowResize: true,
      slidesPerView: 4,
      spaceBetween: 70,
      speed: 400,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        460: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });
    slider.init();
    slider.on('reachEnd', () => {
      if (this.page < this.numberPagesResult) {
        this.page += 1;
        this.renderNextPage();
      }
    });
    slider.on('reachBeginning', () => {
      if (this.page !== DEFAULT_PAGE) {
        this.page -= 1;
        this.renderNextPage();
      }
    });
  }

  createFalseResponseArea(Error) {
    this.slider = document.createElement('div');
    this.slider.classList.add('swiper-container');
    this.slider.classList.add('flex-centre');
    const sliderArea = document.querySelector('.slider-area');
    this.slider.innerHTML = `<div class="slider_message"><p>${Error}</p></div>`;
    sliderArea.appendChild(this.slider);
  }

  renderNextPage() {
    const swiper = document.querySelector('.swiper-container');
    if (swiper) { swiper.remove(); }
    const serchValue = document.querySelector('.search__input').value;
    if (serchValue === EmptySerchRequest) {
      this.getBySearhcRequest(DEFAULT_SEARCH_REQUEST, this.page);
    } else { this.getBySearhcRequest(serchValue, this.page); }
  }

  checkSerchLanguage(searchRequest) {
    this.languageSerchRu = /[а-я]/i.test(searchRequest);
    return this.languageSerchRu;
  }

  addTextToTranslateArea(transladetSearchRequest = EmptySerchRequest) {
    this.translateTextArea = document.querySelector('.search__translate-area');
    this.translateTextArea.innerHTML = `${transladetSearchRequest}`;
  }
}
